<template>
	<div class="foot_view">
		<div class="footImg">
			<img class="" width="207" src="../../static/img/index/ic_logo.png" />
		</div>
		<div class="other_view">
			<div class="other_item">
				<div class="other_title">{{ $t('footer.aboutUs') }}</div>
				<div class="other_li">
					<div @click="gotoPage('about')">{{ $t('footer.companyProfile') }}</div>
					<div @click="gotoPage('about')">{{ $t('footer.visionAndMission') }}</div>
					<div @click="gotoPage('about')">{{ $t('footer.history') }}</div>
					<div @click="gotoPage('about')">{{ $t('footer.corporateHonor') }}</div>
					<div @click="gotoPage('about')">{{ $t('footer.onlineVisit') }}</div>
				</div>
			</div>
			<div class="other_item">
				<div class="other_title">{{ $t('footer.Win-win') }}</div>
				<div class="other_li">
					<div @click="gotoPage('service')">{{ $t('footer.scenicCooperation') }}</div>
					<div @click="gotoPage('service')">{{ $t('footer.campAlliance') }}</div>
					<div @click="gotoPage('service')">{{ $t('footer.joinRv') }}</div>
					<div @click="gotoPage('service')">{{ $t('footer.guideCooperation') }}</div>
				</div>
			</div>
			<div class="other_item">
				<div class="other_title">{{ $t('footer.yueniyou') }}</div>
				<div class="other_li">
					<div @click="gotoPageIndex(0)">{{ $t('footer.rvCamping') }}</div>
					<div @click="gotoPageIndex(1)">{{ $t('footer.literature') }}</div>
					<div @click="gotoPageIndex(2)">{{ $t('footer.navigationExperience') }}</div>
					<div @click="gotoPageIndex(3)">{{ $t('footer.appDownload') }}</div>
				</div>
			</div>
			<div class="other_item">
				<div class="other_title">{{ $t('footer.learnMore') }}</div>
				<div class="other_li">
					<div @click="gotoPage('news')">{{ $t('footer.news') }}</div>
					<div @click="gotoPage('media')">{{ $t('footer.theme') }}</div>
					<div @click="gotoPage('view')">{{ $t('footer.perspective') }}</div>
				</div>
			</div>
			<div class="other_item">
				<div class="other_title">{{ $t('footer.contactUs') }}</div>
				<div class="other_li">
					<div>{{ $t('footer.contactNumber') }}：4000-155-105</div>
					<div style="max-width: 420px;">{{ $t('footer.administrativeHeadquarters') }}：{{
						$t('footer.addressText2') }}</div>
					<div style="max-width: 420px;">{{ $t('footer.contactAddress') }}：{{ $t('footer.addressText') }}</div>
					<div style="margin-top: 10px;">
						<img width="90" src="../../static/img/index/ic_code.png" />
					</div>
				</div>
			</div>

			<!-- <div class="other_right">
        <div class="right_item">
          <img width="130" src="../../static/img/index/ic_code.png" />
          <div style="color:#fff;font-size:16px;margin-top:10px">约你游APP下载</div>
        </div>
        <div class="right_item">
          <img width="130" src="../../static/img/index/ic_code1.jpg" />
          <div style="color:#fff;font-size:16px;margin-top:10px">快乐车行公众号</div>
        </div>
      </div> -->
		</div>
		<div class="bottom_view_max">
			<div class="group text-222">
				<!-- <span @click="goto('https://www.ezagoo.net/')" style="cursor: pointer;">{{
				$t('footer.ezgGroup') }}</span>
				| <span @click="goto('https://bjzchl.ezagooad.com/')" style="cursor: pointer;">{{ $t('footer.zchl')
				}}</span>
				|  -->
				<span @click="gotoPageIndex(2)" style="cursor: pointer;">{{ $t('footer.ycty')
				}}</span> | <span @click="goto('http://xb.hkstv.tv/fangchelvyou/')" style="cursor: pointer;">{{
	$t('footer.hongkongTV') }}</span></div>
			<br />
			<br />
			Copyright © 2014-{{ year }} klch.cn, 湖南快乐车行露营地投资发展有限公司 版权所有 <span @click="goto('https://beian.miit.gov.cn')"
				style="cursor: pointer;">湘ICP备18019974号</span>
			<span @click="goto('https://tsm.miit.gov.cn/dxxzsp/')" style="cursor: pointer;"> 中华人民共和国增值电信业务经营许可证
				湘B2-20200115</span>
			<br />
			<br />
			<span><img width="93"
					@click="goto('https://cslz.saicjg.com/2430/authority?key=794ab44b45abfe51e5311694a741460f')"
					style="margin-right:10px;cursor: pointer;" src="../../static/img/index/siteBase_cs.png" /><img
					width="25" src="../../static/img/index/ic_ga.png" /></span>
			<span @click="goto('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011202000697')"
				style="cursor: pointer;"> 湘公网安备 43011202000697号</span>
		</div>
		<div class="bottom_view_min">
			<div class="group text-222">
				<!-- <span @click="goto('https://www.ezagoo.net/')" style="cursor: pointer;">{{
				$t('footer.ezgGroup') }}</span>
				| <span @click="goto('https://bjzchl.ezagooad.com/')" style="cursor: pointer;">{{ $t('footer.zchl')
				}}</span>
				|  -->
				<span @click="gotoPageIndex(2)" style="cursor: pointer;">{{ $t('footer.ycty')
				}}</span> | <span @click="goto('http://xb.hkstv.tv/fangchelvyou/')" style="cursor: pointer;">{{
	$t('footer.hongkongTV') }}</span></div>
			<br />
			<br />
			Copyright © 2014-{{ year }} klch.cn <br />湖南快乐车行露营地投资发展有限公司 <br />版权所有<br /> <span
				@click="goto('https://beian.miit.gov.cn')" style="cursor: pointer;">湘ICP备18019974号</span>
			<br /><span @click="goto('https://tsm.miit.gov.cn/dxxzsp/')" style="cursor: pointer;"> 中华人民共和国增值电信业务经营许可证
				<br />湘B2-20200115</span>
			<br />
			<span><img width="93"
					@click="goto('https://cslz.saicjg.com/2430/authority?key=794ab44b45abfe51e5311694a741460f')"
					style="margin-right:10px;cursor: pointer;display:none" src="../../static/img/index/siteBase_cs.png" />
				<img style="display:none" width="25" src="../../static/img/index/ic_ga.png" /></span>
			<span @click="goto('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43011202000697')"
				style="cursor: pointer;"> 湘公网安备 <br />43011202000697号</span>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		//这里存放数据
		return {
			year: '',
		};
	},
	methods: {
		goto(e) {
			window.open(e, '_blank');
			// window.location.href = e;
		},
		gotoPage(e) {
			this.$router.push(e);
		},
		gotoPageIndex(id) {
			this.$router.push({
				path: '/function',
				query: { id: id }
			});
		}

	},
	created() {
		let date = new Date();
		this.year = date.getFullYear();
		console.log(this.year);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.foot_view {
	/* position: fixed; */
	width: 100%;
	background: #fff;
	/* bottom: 0; */
	color: #222;
	text-align: left;

	.footImg {
		max-width: 1440px;
		// text-align: left;
		// margin-left: 300px;
		margin: 0 auto;
		margin-top: 50px;
		margin-bottom: 40px;
	}
}

@media (min-width: 768px) {
	.bottom_view_max {
		display: block;
		text-align: center;
	}

	.bottom_view_min {
		display: none !important;
	}
}

@media (max-width: 576px) {
	.other_view {
		display: none !important;
	}

	.bottom_view_max {
		display: none !important;
	}
}



.other_view {
	/* background: #313131; */
	/* color: #fff; */
	font-size: 16px;
	padding: 60px 0;
	display: flex;
	flex-direction: row;
	/* width: 1200px; */
	margin: 0 auto;
	/* justify-content: center;
	 */
	justify-content: space-between;
	max-width: 1440px;
	border-top: 1px solid #E9E9E9;
}

.other_item {
	/* margin-left: 50px; */
	text-align: start;
	line-height: 2;
	/* width: 162px; */
}

.other_title {
	margin-bottom: 10px;
	color: #222;
	font-size: 18px;
	font-weight: bold;
}

.other_li {
	color: #222;
	cursor: pointer;
}



.bottom_view_min {
	/* position: fixed;
	bottom: 0px; */
	color: #999;
	font-size: 12px;
	width: 100%;
	line-height: 1.8;
	padding: 20px 10px;
	/* background: rgba(0, 0, 0, 0.8); */
}

.bottom_view_max {
	/* position: fixed;
	bottom: 0px; */
	color: #999;
	text-align: center;
	font-size: 12px;
	width: 100%;
	padding: 20px 10px;
	/* background: rgba(0, 0, 0, 0.8); */
}

/* a {
	color: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/components/cx-foot.vue